import React from 'react';
import styled from 'styled-components';
import { Body5, Container } from '@ui';
import { DocumentVaultFilterContext, VAULT_FACETS } from '@/contexts/DocumentVaultFilterContext';
import { FacetDropdown } from './FacetDropdown';
import { DateRangeFilter } from './DateRangeFilter';
import { VaultSearchInput } from './VaultSearchInput';
import { SelectionCheckbox } from '../selection/SelectionCheckbox';

const BarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

const ToggleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
`;

export const VaultFilterBar = ({ facetOptions }) => {
  const { filters, toggleFacetValue, clearFacet, setCleanEligibleOnly } = React.useContext(DocumentVaultFilterContext);

  return (
    <Container>
      <BarWrapper>
        <VaultSearchInput />
      </BarWrapper>
      <Container top={12}>
        <BarWrapper>
          <FacetDropdown
            label="Company"
            options={facetOptions.tickers}
            selectedValues={filters.tickers}
            onToggleValue={(value) => toggleFacetValue(VAULT_FACETS.tickers, value)}
            onClear={() => clearFacet(VAULT_FACETS.tickers)}
          />
          <FacetDropdown
            label="Type"
            options={facetOptions.docTypes}
            selectedValues={filters.docTypes}
            onToggleValue={(value) => toggleFacetValue(VAULT_FACETS.docTypes, value)}
            onClear={() => clearFacet(VAULT_FACETS.docTypes)}
          />
          <FacetDropdown
            label="Tags"
            options={facetOptions.tags}
            selectedValues={filters.tags}
            onToggleValue={(value) => toggleFacetValue(VAULT_FACETS.tags, value)}
            onClear={() => clearFacet(VAULT_FACETS.tags)}
          />
          <DateRangeFilter />
          <FacetDropdown
            label="Status"
            options={facetOptions.statuses}
            selectedValues={filters.statuses}
            onToggleValue={(value) => toggleFacetValue(VAULT_FACETS.statuses, value)}
            onClear={() => clearFacet(VAULT_FACETS.statuses)}
          />
          <FacetDropdown
            label="Format"
            options={facetOptions.fileFormats}
            selectedValues={filters.fileFormats}
            onToggleValue={(value) => toggleFacetValue(VAULT_FACETS.fileFormats, value)}
            onClear={() => clearFacet(VAULT_FACETS.fileFormats)}
          />
          <ToggleWrapper onClick={() => setCleanEligibleOnly(!filters.cleanEligibleOnly)}>
            <SelectionCheckbox
              isChecked={filters.cleanEligibleOnly}
              onChange={setCleanEligibleOnly}
              ariaLabel="Clean-copy eligible only"
            />
            <Body5>Clean-copy eligible only</Body5>
          </ToggleWrapper>
        </BarWrapper>
      </Container>
    </Container>
  );
};
